import styles from './index.less';
import {Toast} from 'antd-mobile';
import agent from "../utils/agent";
import {Map, Marker, Markers} from "react-amap";
import Router from "next/router";
import PageWrapper from "./PageWrapper";

class Page extends React.Component {

    state = {
        name: null,
        shopList: [],
        showShopList: [],
        cityList: ['全部'],
        markList: [],
        selectedShop: null,
        selectedCity: '全部',
    };

    constructor() {
        super();
        const _this = this;

        this.mapEvents = {
            created: (map) => {
                _this.map = map;
                let infoWindowContent = '<div class="infowindow-content"><div class="amap-info-header">方恒国际中心</div><div class="amap-info-body">阜通东大街6号</div></div>'
                let addInfoWin;
                AMap.plugin('AMap.AdvancedInfoWindow', function () {
                    addInfoWin = new AMap.AdvancedInfoWindow({
                        panel: 'panel',
                        closeWhenClickMap: true,
                        placeSearch: false,
                        asOrigin: true,
                        asDestination: true,
                        content: infoWindowContent
                    });
                    _this.infoWindow = addInfoWin;
                });
                AMap.plugin('AMap.Geolocation', function () {
                    _this.geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                        maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                        convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                        showButton: true,        //显示定位按钮，默认：true
                        buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
                        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                        showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                        panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
                        zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    });
                });
            },
        };

        this.markerEvents = {
            created(markers) {
                _this.map.setFitView(markers);
            },
            click: (e) => {
                const {target} = e;
                const extData = target.B.extData.extData;
                this.openShopInfoWindow(extData);
            },
        }
    }

    async componentDidMount() {
        try {
            Toast.loading('加载中...', 0);
            const data = await agent.Shop.findAll({
                ps: 999
            });
            const shopList = data.list || [];
            const cityList = ['全部'];
            shopList.forEach(shop => {
                cityList.push(shop.city);
            });
            this.setState({
                shopList,
                showShopList: shopList,
                cityList: Array.from(new Set(cityList)),
            });
        } catch (e) {
            console.log(e);
        } finally {
            Toast.hide();
        }
    }

    handleNavi = (shop) => {
        this.handleGoTop();
        this.openShopInfoWindow(shop);
    };

    handleClear = () => {
        this.infoWindow.clear();
        this.setState({
            selectedShop: null,
        });
    };

    handleGoTop = () => {
        window.scrollTo(0, 0);
    };

    openShopInfoWindow = shop => {
        this.setState({
            selectedShop: shop
        });
        const {lng, lat} = shop;
        const content = ' <div class="infoWindow" style="padding: 10px;">' +
            '<div class="name" style="font-size: 18px;">' + shop.name + '</div> ' +
            '<div class="address" style="margin-top: 4px;">' + shop.address + '</div> ' +
            '</div>';
        // this.map.setCenter({
        //     lng, lat
        // });
        this.infoWindow.setContent(content);
        this.infoWindow.open(this.map, [lng, lat]);
        setTimeout(() => {
            this.map.setZoomAndCenter(12, [lng, lat]);
        }, 100);
    }

    handleInput = e => {
        const {selectedCity} = this.state;
        const name = e.target.value;
        this.setState({
            name
        });
        this.filter(name, selectedCity);
    };

    handleSelectCity = e => {
        const {name} = this.state;
        const selectedCity = e.target.value;
        this.setState({
            selectedCity,
        });
        this.filter(name, selectedCity);
    };

    handleLocate = () => {
        Toast.loading('定位中...', 0);
        this.geolocation.getCurrentPosition((status, result) => {
            console.log(status, result);
            try {
                const {showShopList} = this.state;
                const location = new AMap.LngLat(result.position.lng, result.position.lat);
                const sortedShopList = showShopList.sort((a, b) => {
                    return location.distance(new AMap.LngLat(a.lng, a.lat)) - location.distance(new AMap.LngLat(b.lng, b.lat));
                }).sort();
                console.log(sortedShopList);
                this.setState({
                    showShopList: sortedShopList,
                });
                Toast.hide();
            } catch (e) {
                Toast.show('微信中不能直接获取到位置');
                // Toast.hide();
            }
        });
    };

    filter = (name, selectedCity) => {
        this.setState({
            showShopList: this.state.shopList.filter(shop => {
                return ((shop.city === selectedCity) || (selectedCity === '全部')) &&
                    (!name || (shop.name.indexOf(name) > -1));
            }),
        });
    };

    handleViewShop = (shop) => {
        console.log(shop);
        Router.push('/shop?shopId=' + shop.id);
    };

    render() {
        const {showShopList = [], cityList = [], selectedShop, name, selectedCity} = this.state;
        const plugins = [
            'Scale',
            // 'OverView',
            'ControlBar', // v1.1.0 新增
            {
                name: 'ToolBar',
                options: {
                    visible: true,  // 不设置该属性默认就是 true
                    onCreated(ins) {
                        console.log(ins);
                    },
                },
            }
        ];
        const markerList = showShopList.map(shop => {
            return {
                extData: shop,
                position: {
                    longitude: shop.lng,
                    latitude: shop.lat,
                },
            };
        });

        return (
            <div className={styles.page}>
                <div className={styles.header}>
                    <img className={styles.logo} src={'https://crispi.oss-cn-hangzhou.aliyuncs.com/h5/logo.png'} />
                </div>
                <div className={styles.map}>
                    <Map amapkey={'57819843b331075ca4b9960b8f9185bd'}
                         events={this.mapEvents}
                         plugins={plugins}
                    >
                        <Markers events={this.markerEvents} markers={markerList}/>
                    </Map>
                </div>
                {selectedShop && (
                    <div id="panel"/>
                )}
                <div>
                    <div className={styles.searchBar}>
                        <h1>查找门店</h1>
                        <div className={styles.searchItem}>
                            <input type="text" name="address" onInput={this.handleInput.bind(this)}
                                   className={styles.searchBox} placeholder="输入地址"/>
                            <div className={styles.cityBox}>
                                <select name="city" value={this.state.selectedCity} className={styles.city}
                                        onChange={this.handleSelectCity.bind(this)}>
                                    {cityList.map(city => {
                                        return (
                                            <option key={city} value={city}>{city}</option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <button type="button"
                                // onClick={this.handleLocate.bind(this)}
                                className={styles.searchButton}>立即搜索
                        </button>
                    </div>
                    <div
                        className={styles.statList}>{showShopList.length}间店在 {name ? name : (selectedCity !== '全部' ? selectedCity : '中国')}</div>
                    <div className={styles.shopList}>
                        {showShopList.map(shop => {
                            return (
                                <div key={`shop-${shop.id}`} className={styles.shopItem}>
                                    <div className={styles.shop}>
                                        <div className={styles.top} onClick={this.handleViewShop.bind(this, shop)}>
                                            <div className={styles.name}>{shop.name}</div>
                                        </div>
                                        <div className={styles.mid} onClick={this.handleViewShop.bind(this, shop)}>
                                            <div className={styles.cover} style={{backgroundImage: "url('" + shop.imgList[0] + "')"}}></div>
                                            <div className={styles.right}>
                                                <div className={styles.contact}>联系方式：{shop.contact}</div>
                                                <div className={styles.time}>营业时间：{shop.businessTime}</div>
                                            </div>
                                        </div>
                                        <div className={styles.bottom}>
                                            <img className={styles.icon}
                                                 src={'https://crispi.oss-cn-hangzhou.aliyuncs.com/h5/address.png'}/>
                                            <div className={styles.address}>{shop.address}</div>
                                            <div className={styles.navi}
                                                 onClick={this.handleNavi.bind(this, shop)}>路线导航
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.footer}>
                    <img src={'https://crispi.oss-cn-hangzhou.aliyuncs.com/h5/footer.png'}/>
                </div>
                <div className={styles.clear} onClick={this.handleClear.bind(this)}>
                    <img src={'https://crispi.oss-cn-hangzhou.aliyuncs.com/h5/home.png'}/>
                </div>
                <div className={styles.goTop} onClick={this.handleGoTop.bind(this)}>
                    <img src={'https://crispi.oss-cn-hangzhou.aliyuncs.com/h5/top.png'}/>
                </div>
            </div>
        );
    }
}

export default PageWrapper(Page);
